import React, { useRef, useState } from 'react';
import { Button, Box, Stack } from '@mui/material';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { useReactToPrint } from 'react-to-print';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { downloadReciept, getCartItems } from '../../../../redux/features/cartSlice';
import { useLocation } from 'react-router-dom';

const DownloadPaymentReciept = ({ invoiceId, paidStatus }) => {
  const [open, setOpen] = useState(false);
  const [printing, setPrinting] = useState(false);
  const iframeRef = useRef(null);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const leadIdParams = params.get('leadId');

  const encodedInvoiceId = btoa(invoiceId?.toString() || '');
  const receiptUrl = `https://pay.intervaledu.com/hdfc/success/${encodedInvoiceId}`;

  const handlePrintDirect = useReactToPrint({
    content: () => iframeRef.current,
    documentTitle: `Payment_Receipt_${invoiceId}`,
    onBeforePrint: () => setPrinting(true),
    onAfterPrint: () => setPrinting(false),
  });

  const handleDownload = async () => {
    try {
      setPrinting(true);
      const res = await dispatch(downloadReciept(invoiceId)).unwrap(); // unwrap gives payload directly
      if (res.status === 'success') {
        const leadId = location?.state?.leadId;
        enqueueSnackbar(res.message, { variant: 'success' });
        handlePrintDirect();
        dispatch(getCartItems(leadId || leadIdParams));
      } else {
        enqueueSnackbar('Failed to generate receipt', { variant: 'error' });
      }
    } catch (err) {
      console.error('Error downloading receipt:', err);
      enqueueSnackbar('Error downloading receipt', { variant: 'error' });
    } finally {
      setPrinting(false);
    }
  };

  return (
    <GlobalDialog
      title={'Payment Receipt'}
      open={open}
      setOpen={setOpen}
      fullScreen
      closeButton
      popupButton={
        <Button disabled={paidStatus == 1 ? false : true} onClick={() => setOpen(true)}>
          View Receipt
        </Button>
      }
      content={
        <Box sx={{ height: '80vh', width: '100%', position: 'relative' }}>
          {open && (
            <iframe
              ref={iframeRef}
              src={receiptUrl}
              title="Payment Receipt"
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            />
          )}

          <Stack
            direction="row"
            justifyContent="center"
            sx={{
              mt: 2,
              position: 'absolute',
              bottom: 16,
              left: 0,
              right: 0,
              zIndex: 9999,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownload}
              disabled={printing}
              sx={{ textTransform: 'none', borderRadius: 2, px: 4 }}
            >
              {printing ? 'Downloading...' : 'Download PDF'}
            </Button>
          </Stack>
        </Box>
      }
    />
  );
};

export default DownloadPaymentReciept;
